import { render } from "./PlaceOverviewPage.vue?vue&type=template&id=4efa6e28&scoped=true"
import script from "./PlaceOverviewPage.vue?vue&type=script&lang=js"
export * from "./PlaceOverviewPage.vue?vue&type=script&lang=js"

import "./PlaceOverviewPage.vue?vue&type=style&index=0&id=4efa6e28&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mlp/mlp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4efa6e28"]])

export default __exports__